// Import: Packages
import React from "react";
import Fjernlager from "../../../../Fjernlager";
import { Col } from "../../../../grid";
import { LinkStyled, Paragraph } from "../../../../typography";
import BuyButtons2 from "../../../Item/BuyButtons2";
import BuyButtonsFadoel from "../../../Item/BuyButtonsFadoel";
import { FustagerWithoutAnlaeg } from "../../../../../containers/commerce";

const ButtonsPicker = ({ amount, actions, smallScreen }) => {
  if (smallScreen) {
    return <BuyButtonsFadoel fullWidthBig amount={amount} actions={actions} />;
  }
  return <BuyButtons2 amount={amount} actions={actions} />;
};

const Warning = ({ children }) => (
  <Paragraph red fontSize="16px">
    {children}
  </Paragraph>
);

const RenderButtons = ({
  amount,
  actions,
  notice,
  inStock,
  inStockText,
  smallScreen,
}) => {
  if (inStock === "-1" && !inStockText) {
    return <Warning>Midlertidigt udsolgt fra producenten</Warning>;
  }
  if (inStock === "-1" && inStockText) {
    return <Warning>{inStockText()}</Warning>;
  }
  if (inStock === "100") {
    return <Warning>Udgået fra producenten</Warning>;
  }
  if (inStock <= -2) {
    return (
      <React.Fragment>
        <Paragraph blue marginBottom="10px" paddingTop="10px">
          <Fjernlager inStock={inStock} />
        </Paragraph>
        <ButtonsPicker
          amount={amount}
          actions={actions}
          smallScreen={smallScreen}
        />
      </React.Fragment>
    );
  }
  if (notice) {
    return (
      <React.Fragment>
        <Paragraph>{notice()}</Paragraph>
        <ButtonsPicker
          amount={amount}
          actions={actions}
          smallScreen={smallScreen}
        />
      </React.Fragment>
    );
  }
  return (
    <ButtonsPicker
      amount={amount}
      actions={actions}
      smallScreen={smallScreen}
    />
  );
};

// Wrap <Col> around <RenderButtons>
const RenderButtonsWrapper = ({
  amount,
  actions,
  notice,
  inStock,
  inStockText,
  smallScreen,
}) => (
  <Col xs={12}>
    <RenderButtons
      amount={amount}
      actions={actions}
      notice={notice}
      inStock={inStock}
      inStockText={inStockText}
      smallScreen={smallScreen}
    />
    {amount > 0 && (
      <FustagerWithoutAnlaeg>
        {(fustagerWithoutAnlaeg) =>
          fustagerWithoutAnlaeg && (
            <Paragraph marginTop="15px">
              Skal du bruge{" "}
              <LinkStyled to="/fadoelsanlaeg">fadølsanlæg?</LinkStyled>
            </Paragraph>
          )
        }
      </FustagerWithoutAnlaeg>
    )}
  </Col>
);

export default RenderButtonsWrapper;
